import React from 'react';
import './CookiesPage.css';

const CookiesPage = () => {
  return (
    <div className="min-h-screen bg-black">
      <div className="bg-gradient-to-r from-teal-800 to-cyan-900 w-full">
        <div className="max-w-6xl mx-auto text-center py-16 px-4">
          <h1 className="text-4xl font-bold text-white mb-2">Cookie Policy</h1>
          <p className="text-teal-100 max-w-2xl mx-auto">
            Last updated: {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
      
      <div className="max-w-3xl mx-auto px-6">
        <div className="terms-content py-16 text-left">
          <section className="mb-8">
            <p className="terms-intro text-lg">
              This Cookie Policy explains how elef89 uses cookies and similar technologies to recognize
              you when you visit our website. It explains what these technologies are and why we use them.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">What are cookies?</h2>
            <p>
              Cookies are small data files that are placed on your computer or mobile device when you visit
              a website. Cookies are widely used by website owners to make their websites work efficiently
              and provide reporting information.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">How we use cookies</h2>
            <p>
              We use cookies for several reasons. Some cookies are required for technical reasons for our
              website to operate. Other cookies enable us to track and target the interests of our users to
              enhance the experience on our website.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Types of cookies we use</h2>
            <div className="cookie-types">
              <p className="mb-3">
                <strong>Essential cookies:</strong> These are cookies that are required
                for the operation of our website.
              </p>
              <p className="mb-3">
                <strong>Analytical cookies:</strong> These allow us to recognize and
                count the number of visitors and to see how visitors move around our website when they are using it.
              </p>
              <p>
                <strong>Functionality cookies:</strong> These are used to recognize you
                when you return to our website.
              </p>
            </div>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">How to control cookies</h2>
            <p>
              You can set your browser to refuse all or some browser cookies, or to alert you when websites
              set or access cookies. If you disable or refuse cookies, please note that some parts of this
              website may become inaccessible or not function properly.
            </p>
          </section>
          
          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Contact</h2>
            <p className="mb-2">
              If you have any questions about our Cookie Policy, please contact us at:
            </p>
            <p className="contact-info">
              📧 <a href="mailto:davidd@elef89.com" className="text-teal-400 hover:text-teal-300">davidd@elef89.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default CookiesPage; 